import { useEffect, useState } from 'react';
import { useSyncStore } from '../sync/store';
import { syncSocket } from '../sync/socket';
import { offlineQueue } from '../sync/queue';

function label(state: ReturnType<typeof syncSocket.getState>, queue: number): {
  text: string;
  color: string;
  icon: string;
} {
  if (queue > 0) {
    return { text: `离线 · ${queue} 个待同步`, color: 'text-orange-600 dark:text-orange-400', icon: '⏳' };
  }
  switch (state) {
    case 'connected':
      return { text: '已同步', color: 'text-green-600 dark:text-green-400', icon: '✓' };
    case 'connecting':
    case 'reconnecting':
      return { text: '同步中…', color: 'text-blue-600 dark:text-blue-400', icon: '↻' };
    case 'offline':
    case 'idle':
      return { text: '离线', color: 'text-gray-400', icon: '⚠' };
  }
}

export function SyncIndicator() {
  const socketState = useSyncStore((s) => s.socketState);
  const queueSize = useSyncStore((s) => s.queueSize);
  const lastSyncedAt = useSyncStore((s) => s.lastSyncedAt);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(t);
  }, []);

  const l = label(socketState, queueSize);

  // 实时刷新队列大小 (跨标签页)
  useEffect(() => {
    const sync = () => useSyncStore.getState().setQueueSize(offlineQueue.size());
    const t = setInterval(sync, 2000);
    return () => clearInterval(t);
  }, []);

  let subtitle: string | null = null;
  if (lastSyncedAt && socketState === 'connected' && queueSize === 0) {
    const diff = now - lastSyncedAt;
    if (diff < 60_000) subtitle = '刚刚同步';
    else if (diff < 3_600_000) subtitle = `${Math.floor(diff / 60_000)} 分钟前同步`;
    else subtitle = `${Math.floor(diff / 3_600_000)} 小时前同步`;
  }

  return (
    <div className={`flex items-center gap-1.5 text-xs ${l.color}`}>
      <span>{l.icon}</span>
      <span>{l.text}</span>
      {subtitle && <span className="text-gray-400">· {subtitle}</span>}
    </div>
  );
}